import { alpha, Box, Stack, Typography } from '@mui/material';

/**
 * Icon-headed section used in instruction sidebars (upload forms).
 * The icon sits in a soft-tinted square to match the form's accent
 * color; the title is a slightly heavier subtitle2.
 */
const InfoSection = ({ icon, title, children }) => (
  <Box>
    <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.75 }}>
      <Box
        sx={{
          width: 24,
          height: 24,
          borderRadius: 0.75,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: (theme) => alpha(theme.palette.primary.main, 0.12),
          color: 'primary.main',
        }}
      >
        {icon}
      </Box>
      <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
        {title}
      </Typography>
    </Stack>
    <Box sx={{ pl: 4 }}>{children}</Box>
  </Box>
);

export default InfoSection;
